import { render, staticRenderFns } from "./SearchSendNm.vue?vue&type=template&id=f548c53a&scoped=true&"
import script from "./SearchSendNm.vue?vue&type=script&lang=js&"
export * from "./SearchSendNm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f548c53a",
  null
  
)

export default component.exports